<template>
  <h1 class="member-page-title wd-pt-6 wd-pb-3 wd-font-500 wd-text-otempmax wd-text-black50 sm:wd-pt-10 sm:wd-pb-6">{{ props.title }}</h1>
</template>

<script lang="ts" setup>
interface Props {
  title: string
}

const props = defineProps<Props>()
</script>
